import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userJournalsColumns = [
    { field: 'journalDatetime', name: 'Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'journalCategory', name: 'Category', dataType: 'string' },
    {
        field: 'journalPrompt',
        name: 'Prompt',
        dataType: 'string',
        styles: { minWidth: '30rem' },
    },
];

const UserJournals = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userJournalsColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.journalDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Journals',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Journals Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows journal entries created by users. Each row
                    represents a single journal entry with the prompt that was used.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Date">
                    When the journal entry was created.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Category">
                    The category or type of journal entry selected by the user.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Prompt">
                    The writing prompt or question that guided the user's journal entry.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserJournals;
